module.exports = __webpack_public_path__ + "static/media/footui_11.fa1d35d9.gif";